module.exports = __webpack_public_path__ + "img/1567118373.9ef0d463.jpg";